import React from 'react';

// ///////////////// LAZY LOAD ////////////////////////////
import Loadable from 'react-loadable';
import Loading from './common_components/Loading';

const AsyncMain = Loadable({
  loader: () => import('./homer_components/Main'),
  loading: Loading
});
// ///////////////////////////////////////////////////////

export default props => <AsyncMain {...props} />;
